import axios from 'axios';
import { saveAs } from 'file-saver';
import React, { useEffect, useRef, useState } from 'react'
import { jwt, ud, SERVER_IP, PORT, changeUserInfo, Communication_obj, auth_response_flow, UpdateLicense } from '../../Server'
import socketIo from 'socket.io-client';

var socket = socketIo(SERVER_IP, { transports: ["websocket"] });
export default function Videochatbox(props) {
    const { modal, setModal, room_id } = props;
    const [input, setInput] = useState({ message: '', file: '' })
    const [loading, setLoading] = useState(false)
    const [messages, setMessages] = useState([])
    const fileClick = useRef(null)
    const downloadClick = useRef(null)
    const onChange = (e) => {
      setInput({ ...input, [e.target.name]: e.target.value })
    }

    const bottomRef = useRef(null);
    const [uploadableimg, setUploadableimg] = useState({
      file: { id: '', name: '', obj: '', imgSrc: '', imgShow: false }
    })

    const downloadFile = (file_url, file_name) => {
      saveAs(file_url, file_name);
    }

    const uploadFile = async (e) => {
      setLoading(true)
      const id = e.target.id;
      const name = e.target.files[0].name;
      const size = e.target.files[0].size;
      const obj = e.target.files[0];
      // const obj = await toBase64(e.target.files[0])
      const imgSrc = URL.createObjectURL(e.target.files[0]);
      const imgShow = true;
      setUploadableimg({ ...uploadableimg, file: { id, name, obj, imgSrc, imgShow } })

      // Api Call
      const formData = new FormData();
      formData.append('chat_file', obj);
      let headers = {
        'Content-Type': 'multipart/form-data',
        'user_id': (ud.id).toString(),
        'session_id': (ud.session_id).toString(),
        'user_type': (ud.usertype).toString(),
        'main_id': (ud.main_id).toString(),
        'jwt_token': (jwt),
        'c_id': (ud.c_id).toString()
      }
      const result = await axios.post(`${SERVER_IP}/chat/file/upload`, formData, { withCredentials: true, headers: headers })
      if(!result.data.error){
        const sendData = {
          error: false,
          message_status: "Message sent successfully",
          event: 'SEND_MESSAGE',
          chat_type: 'IMAGE',
          from_id: ud.id,
          to_id: room_id,
          room_id: room_id,
          data: [{
            nonremovable: 0,
            datetime: formatDate(new Date())+" "+new Date().toLocaleTimeString(),
            message: "",
            message_id: "",
            message_type: 'IMAGE',
            file: result.data.file_path,
            file_size: result.data.file_in_byte,
            file_name: result.data.file_name,
            from_name: ud.username,
            to_name: "",
            from_email: ud.email,
            to_email: "",
            from_icon: ud.cooperate_logo.split('/icons/')[1],
            to_icon: "",
            // to_icon: `${SERVER_IP}/icons/${data.profile}`,
            from_user_id: ud.id,
            from_profile: "",
            to_profile: "",
            to_user_id: room_id,
            message_thumbnail: "",
            readStatus: ""
          }]
        }
        socket.emit("VEDIO_B_MESSAGE_EVENT", sendData);
        setLoading(false)
      }
      return () => {
        socket.off();
      }
    }

    const messageSeen = () => {
      // Message Seen Emit
      const ACKNOWLEDGEData = {
        error: false,
        message_status: "No record found",
        event: "ACKNOWLEDGE_MESSAGE",
        chat_type: "",
        from_id: ud.id,
        to_id: room_id,
        room_id: room_id,
        data: []
      }
      socket.emit("VEDIO_B_MESSAGE_EVENT", ACKNOWLEDGEData)
    }

    const allMessage = () => {
      const GET_USER_MESSAGESData = {
        error: false,
        message_status: "No record found",
        event: "GET_USER_MESSAGES",
        chat_type: "",
        from_id: ud.id,
        to_id: room_id,
        room_id: room_id,
        data: []
      }
      // All Messages Emit
      socket.emit("VEDIO_B_MESSAGE_EVENT", GET_USER_MESSAGESData)
      // All Messages Received
      socket.on("VEDIO_F_MESSAGE_EVENT", receivedData => {
        if (receivedData.event=='GET_USER_MESSAGES') {
        setMessages(receivedData.data)
      }
      });
    }

    const deleteMsg = (message_id) => {
      const DELETE_MESSAGEData = {
        error: false,
        message_status: "No record found",
        event: "DELETE_MESSAGE",
        chat_type: "",
        from_id: ud.id,
        to_id: room_id,
        room_id: room_id,
	      message_id,
        data: []
      }
      socket.emit("VEDIO_B_MESSAGE_EVENT", DELETE_MESSAGEData)
      const newArr = []
      messages.forEach(element => {
        if (element.message_id==message_id) {
          element.delete_msg = true;
        }
        newArr.push(element)
      });
      setMessages(newArr)
    }

    //Date Format 2022-07-27 
    const formatDate = (date) => {
      let d = new Date(date);
      let month = (d.getMonth() + 1).toString();
      let day = d.getDate().toString();
      let year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      return [year, month, day].join('-');
    }

    const sendMessage = (e) => {
      e.preventDefault();
      const sendData = {
        error: false,
        message_status: "Message sent successfully",
        event: 'SEND_MESSAGE',
        chat_type: 'TEXT',
        from_id: ud.id,
        to_id: room_id,
        room_id: room_id,
        data: [{
          nonremovable: 0,
          datetime: formatDate(new Date())+" "+new Date().toLocaleTimeString(),
          message: input.message,
          message_id: "",
          message_type: 'TEXT',
          file: "",
          from_name: ud.username,
          to_name: "",
          from_email: ud.email,
          to_email: "",
          from_icon: ud.cooperate_logo.split('/icons/')[1],
          to_icon: "",
          from_user_id: ud.id,
          from_profile: "",
          to_profile: "",
          to_user_id: room_id,
          message_thumbnail: "",
          readStatus: ""
        }]
      }
      socket.emit("VEDIO_B_MESSAGE_EVENT", sendData);
      setInput({ ...input, message: '' })
      return () => {
        socket.off();
      }
    }

    useEffect(() => {
      allMessage()
      messageSeen()
    }, [])

    useEffect(() => {
      // Message Seen Received
      socket.on("VEDIO_F_MESSAGE_EVENT", receivedData => {
        if (receivedData.event=='SEND_MESSAGE') {
          const newArr = [ ...messages ];
          receivedData.data.forEach(element => {
            newArr.push(element)
          });
          setMessages(newArr)
        }
      });
    });

    useEffect(() => {
      bottomRef.current.scrollTo(0, bottomRef.current.scrollHeight)
    }, [messages, loading]);

    return (
      <>
        <div className="modal-dialog modal-dialog-scrollable" style={{height: '45rem', marginRight: '0.5rem'}}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="chat-modal-label">Messages</h5>
              <button type="button" className="btn btn-outline-primary" data-dismiss="modal" onClick={()=>setModal({ ...modal, videochatbox: false })}><i className="fa-solid fa-xmark"></i></button>
            </div>
            <div className="modal-body">
              <div ref={bottomRef} className="msg_history" id="msg_history">
                    {messages.map((element, index)=>{
                      return (
                        <>
                        {ud.id==element.from_user_id ? element.nonremovable==true ?
                        // Invite, Joined And Left Message
                        <div className="outgoing_msg" key={index}>
                        <div className="sent_msg" style={{display: 'flex', alignItems: 'center'}}>
                          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <p style={{backgroundColor: 'rgb(194, 194, 194, 1)'}}>{element.message}</p>
                          </div>
                        </div>
                        </div> :
                        element.delete_msg==true?
                        // Delete: This message was deleted
                        <div className="outgoing_msg" key={index}>
                          <div className="sent_msg" style={{display: 'flex', alignItems: 'flex-end'}}>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                              <span className="name">{element.from_name}</span>
                              <span className="date">{element.datetime?.split(' ')[0]}</span>                              
                              <p style={{backgroundColor: 'rgb(185, 49, 47)'}}>This message was deleted</p>
                              <span className="time">{element.datetime?.split(' ')[1]} {element.datetime?.split(' ')[2]}</span>
                            </div>
                            <div style={{width: '30px', height: '96px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end', marginLeft: '5px'}}>
                              <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={`${SERVER_IP}/icons/${element.from_icon}`} alt="img" /></div>
                            </div>
                          </div>
                        </div>
                        :
                        // Outgoing
                        element.message_type=='IMAGE' || element.message_type=='VIDEO' || element.message_type=='AUDIO' || element.message_type=='FILE'?
                        <div className="outgoing_msg" key={index}>
                        {element.file?.split('https://milan1.azurewebsites.net/')[1]?.split('.')[1]=='png' || element.file?.split('https://milan1.azurewebsites.net/')[1]?.split('.')[1]=='jpg'?                                              
                          <div id='deleteMsgHov' className="sent_msg" style={{display: 'flex'}}>
                          <i className="fa-solid fa-trash" id='deleteMsgIcon' style={{cursor: 'pointer'}} onClick={()=>deleteMsg(element.message_id)}></i>
                          <div className="sent_withd_msg">
                            <div style={{display: 'flex', alignItems: 'flex-end'}}>
                              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                                <span className="name">{element.from_name}</span>
                                <span className="date">{element.datetime?.split(' ')[0]}</span>
                                <div className="sent_file_msg">
                                <div className='received_file_div'>
                                  <img style={{borderRadius: '50%'}} src={element.file} alt="Uploaded Image" />
                                  <div className='received_file_txt'>
                                    <p>{element.file_name}</p>
                                  </div>
                                </div>
                                <button type="button" className="btn btn-outline-light w-100" onClick={()=>downloadFile(element.file, element.file_name)}><i className="fa-solid fa-download"></i></button>
                                </div>
                                <span className="time">{element.datetime?.split(' ')[1]} {element.datetime?.split(' ')[2]}</span>
                              </div>
                            </div>
                          </div>
                          <div style={{width: '30px', height: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end', marginLeft: '5px'}}>
                            <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={`${SERVER_IP}/icons/${element.from_icon}`} alt="img" /></div>
                            <i className="fa-solid fa-check-double" style={{marginBottom: '5px', marginLeft: '10px',color: 'green'}}></i>
                          </div>
                        </div>
                        :
                        <div id='deleteMsgHov' className="sent_msg" style={{display: 'flex'}}>
                          <i className="fa-solid fa-trash" id='deleteMsgIcon' style={{cursor: 'pointer'}} onClick={()=>deleteMsg(element.message_id)}></i>
                          <div className="sent_withd_msg">
                          <div style={{display: 'flex', alignItems: 'flex-end'}}>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                              <span className="name">{element.from_name}</span>
                              <span className="date">{element.datetime?.split(' ')[0]}</span>
                              <div className="sent_file_msg">
                              <div className='received_file_div'>
                                <img src="https://www.pngall.com/wp-content/uploads/2018/05/Files-High-Quality-PNG.png" alt="" />
                                <div className='received_file_txt'><p>{element.file_name}</p></div>
                              </div>
                              <button type="button" className="btn btn-outline-light w-100" onClick={()=>downloadFile(element.file, element.file_name)}><i className="fa-solid fa-download"></i></button>
                              </div>
                              <span className="time">{element.datetime?.split(' ')[1]} {element.datetime?.split(' ')[2]}</span>
                            </div>
                          </div>
                          </div>
                          <div style={{width: '30px', height: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end', marginLeft: '5px'}}>
                            <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={`${SERVER_IP}/icons/${element.from_icon}`} alt="img" /></div>
                            <i className="fa-solid fa-check-double" style={{marginBottom: '5px', marginLeft: '10px',color: 'green'}}></i>
                          </div>
                        </div>
                        }
                        </div>:
                        <div className="outgoing_msg" key={index}>
                          <div id='deleteMsgHov' className="sent_msg" style={{display: 'flex', alignItems: 'flex-end'}}>
                            <i className="fa-solid fa-trash" id='deleteMsgIcon' style={{cursor: 'pointer'}} onClick={()=>deleteMsg(element.message_id)}></i>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                              <span className="name">{element.from_name}</span>
                              <span className="date">{element.datetime?.split(' ')[0]}</span>                              
                              <p>{element.message}</p>
                              <span className="time">{element.datetime?.split(' ')[1]} {element.datetime?.split(' ')[2]}</span>
                            </div>
                            <div style={{width: '30px', height: '96px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end', marginLeft: '5px'}}>
                              <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={`${SERVER_IP}/icons/${element.from_icon}`} alt="img" /></div>
                              <i className="fa-solid fa-check-double" style={{marginBottom: '5px', marginLeft: '10px',color: 'green'}}></i>
                            </div>
                          </div>
                        </div>
                        :
                        // Incoming
                        element.nonremovable==true ?
                        // Invite, Joined And Left Message
                        <div className="outgoing_msg" key={index}>
                        <div className="sent_msg" style={{display: 'flex', alignItems: 'center'}}>
                          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <p style={{backgroundColor: 'rgb(194, 194, 194, 1)'}}>{element.message}</p>
                          </div>
                        </div>
                        </div> :
                        element.message_type=='IMAGE' || element.message_type=='VIDEO' || element.message_type=='AUDIO' || element.message_type=='FILE'?
                        <div className="incoming_msg" style={{display: 'flex', justifyContent: 'flex-start'}} key={index}>
                        {element.file?.split('https://milan1.azurewebsites.net/')[1]?.split('.')[1]=='png' || element.file?.split('https://milan1.azurewebsites.net/')[1]?.split('.')[1]=='jpg'?                      
                        <>
                          <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={`${SERVER_IP}/icons/${element.from_icon}`} alt="img" /></div>
                            <div className="received_msg">
                              <div className="received_withd_msg" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                                <span className="name">{element.from_name}</span>
                                <span className="date">{element.datetime?.split(' ')[0]}</span>
                                <div className="received_file_msg">
                                <div className='received_file_div'>
                                  <img style={{borderRadius: '50%'}} src={element.file} alt="Uploaded Image" />
                                  <div className='received_file_txt'>
                                    <p>{element.file_name}</p>
                                  </div>
                                </div>
                                <button type="button" className="btn btn-outline-secondary w-100" onClick={()=>downloadFile(element.file, element.file_name)}><i className="fa-solid fa-download"></i></button>
                                </div>
                                <span className="time">{element.datetime?.split(' ')[1]} {element.datetime?.split(' ')[2]}</span>
                              </div>
                          </div>
                        </>
                        :
                        <>
                          <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={`${SERVER_IP}/icons/${element.from_icon}`} alt="img" /> </div>
                            <div className="received_msg">
                              <div className="received_withd_msg" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                                <span className="name">{element.from_name}</span>
                                <span className="date">{element.datetime?.split(' ')[0]}</span>
                                <div className="received_file_msg">
                                <div className='received_file_div'>
                                  <img src="https://www.pngall.com/wp-content/uploads/2018/05/Files-High-Quality-PNG.png" alt="Uploaded File" />
                                  <div className='received_file_txt'>
                                    <p>{element.file_name}</p>
                                  </div>
                                </div>
                                <button type="button" className="btn btn-outline-secondary w-100" onClick={()=>downloadFile(element.file, element.file_name)}><i className="fa-solid fa-download"></i></button>
                                </div>
                                <span className="time">{element.datetime?.split(' ')[1]} {element.datetime?.split(' ')[2]}</span>
                              </div>
                          </div>
                        </>
                        }
                        </div>:
                        <div className="incoming_msg" key={index}>
                          <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={`${SERVER_IP}/icons/${element.from_icon}`} alt="img" /> </div>
                            <div className="received_msg">
                              <div className="received_withd_msg" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                                <span className="name">{element.from_name}</span>
                                <span className="date">{element.datetime?.split(' ')[0]}</span>
                                <p>{element.message}</p>
                                <span className="time">{element.datetime?.split(' ')[1]} {element.datetime?.split(' ')[2]}</span>
                              </div>
                          </div>
                        </div>
                        }
                        </>
                      )
                    })
                    }

                    {loading &&                  
                    <div className="outgoing_msg" style={{display: 'flex', justifyContent: 'flex-end'}}>
                    {uploadableimg.file.name.split('.')[1]=='png' || uploadableimg.file.name.split('.')[1]=='jpg'?                       
                    <div className="sent_msg" style={{display: 'flex'}}>
                      <div className="sent_withd_msg" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginLeft: '5px'}}>
                        <span className="name">{ud.username}</span>
                        <span className="date">{formatDate(new Date())}</span>
                        <div className="sent_file_msg">
                        <div className='received_file_div'>
                          <img style={{borderRadius: '50%'}} src={uploadableimg.file.imgSrc} alt="Uploaded Image" />
                          <div className='received_file_txt'>
                            <p>{uploadableimg.file.name}</p>
                          </div>
                        </div>
                        <button type="button" disabled className="btn btn-outline-light w-100"><i className="fa fa-refresh fa-spin"></i></button>
                        </div>
                        <span className="time">{new Date().toLocaleTimeString()}</span>
                      </div>
                      <div style={{width: '30px', height: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end', marginLeft: '5px'}}>
                        <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={ud.cooperate_logo} alt="img" /></div>
                        <i className="fa-solid fa-check-double" style={{marginBottom: '5px', marginLeft: '10px',color: 'green'}}></i>
                      </div>
                    </div>
                    :
                    <div className="sent_msg" style={{display: 'flex'}}>
                      <div className="sent_withd_msg" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginLeft: '5px'}}>
                        <span className="name">{ud.username}</span>
                        <span className="date">{formatDate(new Date())}</span>
                        <div className="sent_file_msg">
                        <div className='received_file_div'>
                          <img src="https://www.pngall.com/wp-content/uploads/2018/05/Files-High-Quality-PNG.png" alt="" />
                          <div className='received_file_txt'>
                            <p>{uploadableimg.file.name}</p>
                          </div>
                        </div>
                        <button type="button" disabled className="btn btn-outline-light w-100"><i className="fa fa-refresh fa-spin"></i></button>
                        </div>
                        <span className="time">{new Date().toLocaleTimeString()}</span>
                      </div>
                      <div style={{width: '30px', height: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end'}}>
                        <div className="incoming_msg_img"><img style={{borderRadius: '50%'}} src={ud.cooperate_logo} alt="img" /></div>
                        <i className="fa-solid fa-check-double" style={{marginBottom: '5px', marginLeft: '10px',color: 'green'}}></i>
                      </div>
                    </div>}
                    </div>}

              </div>
              <div className="type_msg">
                <form className="input_msg_write" onSubmit={sendMessage}>
                  <input type="text" className="write_msg"placeholder="Type a message" name="message" value={input.message} onChange={onChange}/>
                  <input style={{display: 'none'}} ref={fileClick} type="file" onChange={uploadFile}/>
                  <button className="file_send_btn" type="button"  onClick={()=>fileClick.current.click()}><i className="fa-solid fa-link" aria-hidden="true"></i></button>
                  <button className="msg_send_btn" type="button" disabled={!input.message} onClick={sendMessage}><i className="fa fa-paper-plane-o" aria-hidden="true"></i></button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    )
}
